
import { defineComponent, onMounted, ref } from 'vue';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/vue/solid';
import { FieldOfStudy } from '@/models/Details';

export default defineComponent({
  name: 'AuthorPage',
  components: {
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    // constants reactive to consider a possible change of the displayed publication
    const statisticsVisible = ref(false);
    const fieldOfStudy = ref(Object as unknown as FieldOfStudy);

    // TODO: fetch author using existing axios
    const fetchFieldOfStudy = (id?: number) => {
      if (id || props.id) {
        let reqId: number;
        if (id) reqId = id;
        else if (props.id) reqId = props.id;
        else {
          emit('fetchFailed');
          return;
        }
        emit('loading');
        fetch('https://api.ambalytics.cloud/entities', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Content-Length': '142' },
          body: `{"query":"query getFieldOfStudy($id: ID!) { fieldOfStudy(id: $id) {id, name, score, normalizedName, level, citationCount, parents{ id, name}, children{ id, name}}}" ,"variables":{"id":"${reqId}"}}`,
        })
          .then((res) => res.json())
          .then((res) => {
            if (!res.data.fieldOfStudy) return; //TODO: reaction to fieldOfStudy == null
            fieldOfStudy.value = { ...res.data.fieldOfStudy };
            emit('stopLoading');
          })
          .catch((reason) => {
            emit('fetchFailed');
            console.error('fetch failed because ' + reason);
          });
      } else {
        emit('fetchFailed');
      }
    };

    onMounted(() => {
      fetchFieldOfStudy();
    });

    const closeStatistics = () => {
      statisticsVisible.value = false;
      document.getElementById('main-content')?.classList.add('col-span-3');
      document.getElementById('main-content')?.classList.remove('col-span-2');
    };
    const openStatistics = () => {
      // ToDo: enable as soon as statistics has content + add hover:text-yellow-400 to main-content
      // statisticsVisible.value = true;
      // document.getElementById('main-content')?.classList.remove('col-span-3');
      // document.getElementById('main-content')?.classList.add('col-span-2');
    };

    const viewNewFieldOfStudy = (id: number) => {
      fetchFieldOfStudy(id);
    };

    return {
      statisticsVisible,
      closeStatistics,
      openStatistics,
      fieldOfStudy,
      viewNewFieldOfStudy,
    };
  },
});
